import { addMoveRecapElements, injectRecapImages } from "./cart";

export function initStep3() {
    if ($('.id--17').length) {
        moveAddStep3Elements()
        loginLink()
        freePrice()
        step3TextChanges()
        injectRecapImages()
        addMoveRecapElements()
    }
}

function loginLink() {
    const loginLink = $('#order-page-login-button');
    loginLink
        .insertAfter('.co-contact-information > h4')
        .wrap('<div class="form-group"></div>')
        .attr('data-target', 'login')
        .text('Bei meinem Konto anmelden');
}

function moveAddStep3Elements() {
    $(`<h4>Ihre Daten</h4>`).insertBefore('.cart-content');
}

function step3TextChanges() {
    $('#submit-order').text('Zahlungspflichtig bestellen');
    $('.btn.next-step-back').text('Einen Schritt zurück');
}

function freePrice() {
    const shippingAndBilling = $(".order-summary-item:not([data-micro='cartItem'])")

    shippingAndBilling.each(function () {
        const price = $(this).find('.cart-item-price')
        if (price.text().trim() === '0 Kč') {
            $(this).addClass('free-price')
            price.text('Zdarma')
        }
    })
}
